var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.value !== "" && _vm.value !== null && _vm.showImage && !_vm.isMp4()
      ? _c("img", {
          attrs: {
            src: _vm.imgPath,
            width: _vm.imgWidth,
            height: _vm.imgHeight,
          },
        })
      : _vm._e(),
    _vm.value !== "" && _vm.value !== null && _vm.showImage && _vm.isMp4()
      ? _c("video", {
          attrs: {
            src: _vm.imgPath,
            width: _vm.imgWidth,
            height: _vm.imgHeight,
            preload: "",
          },
        })
      : _vm._e(),
    _c(
      "div",
      { staticStyle: { display: "flex", "flex-direction": "row" } },
      [
        _c(
          "Upload",
          {
            attrs: {
              "show-upload-list": false,
              data: _vm.uploadParams,
              action: _vm.action,
              format: _vm.format,
              "on-success": _vm.handleUploadFileSuccess,
              "on-format-error": _vm.handleFormatError,
              beforeUpload: _vm.beforeFileUpload,
            },
          },
          [
            _c("Button", { attrs: { icon: "ios-cloud-upload-outline" } }, [
              _vm._v("选择文件"),
            ]),
          ],
          1
        ),
        _vm.value !== "" && !_vm.showImage
          ? _c(
              "div",
              { staticStyle: { "margin-left": "10px" } },
              [
                _c(
                  "Button",
                  {
                    attrs: { icon: "ios-search" },
                    on: {
                      click: function ($event) {
                        return _vm.showImageModal()
                      },
                    },
                  },
                  [_vm._v("查看")]
                ),
              ],
              1
            )
          : _vm._e(),
        _vm.value !== "" && _vm.showFileInNewTab
          ? _c(
              "div",
              { staticStyle: { "margin-left": "10px" } },
              [
                _c(
                  "Button",
                  {
                    attrs: { icon: "ios-search" },
                    on: {
                      click: function ($event) {
                        return _vm.openFileInNewTab()
                      },
                    },
                  },
                  [_vm._v("播放")]
                ),
              ],
              1
            )
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }